<template>
  <div>
      <!-- 面包屑导航区域 -->
    <el-card>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>工资发放结果管理</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <!-- RefundSystem card header area -->
        <el-row>
            <el-col style="text-align:left;" :span="12">
                <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table :data="tableData" v-loading="loading" style="width: 100%" size="small">
                    <el-table-column prop="Years" label="年" width="180"></el-table-column>
                    <el-table-column prop="Months" label="月" width="180"> </el-table-column>
                    <el-table-column prop="Company_Name" label="公司"></el-table-column>
                    <el-table-column prop="Status" :formatter="GetStatus" label="审核状态"></el-table-column>
                    <el-table-column label="工资条发放状态">
                      <template slot-scope="scope">
                        <span>{{ scope.row.GrantStatus==0?"未发放":(scope.row.GrantStatus==1?"已发放":"已撤回") }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" style="color:red" v-if="scope.row.GrantStatus==0||scope.row.GrantStatus==2" size="mini" @click="sendAll(scope.row)">发放</el-button>
                            <el-button type="text" v-if="scope.row.GrantStatus!=0&&scope.row.GrantStatus!=2" size="mini" @click="cancelAll(scope.row)">撤回</el-button>
                            <el-button type="text" size="mini" @click="sendonly(scope.row)">单独发放某人</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
      </el-row>
      <el-row>
        <el-col style="text-align:right;" :span="24">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
            style="float:right"
          ></el-pagination>
        </el-col>
      </el-row>
      <el-dialog
        width="50%"
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        top="10px"
      >
        <el-row>
          <el-col :span="12">
              <el-form :model="user" ref="taskForm" label-width="150px">
                  <el-form-item label="选择发放人员">
                    <el-select v-model="user.usercode" @change="selectGetUser" filterable="" placeholder="请选择选择发放人员">
                        <el-option v-for="item in data" :label="item.userName" :value="item.userCode" :key="item.userCode"></el-option>
                        <!-- <el-option label="区域二" value="beijing"></el-option> -->
                    </el-select>
                </el-form-item>
              </el-form>
          </el-col>
          <el-col style="margin-left:20px;" :span="10">
            {{sendUser}}
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="sendData">保存</el-button>
          <el-button @click="dialogVisible = false;sendUser='';sendUsercode=''">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        width="50%"
        :title="dialogTitle1"
        :visible.sync="dialogVisible1"
        top="10px"
      >
        <el-row>
          <el-col :span="12">
              <el-form :model="user" ref="taskForm" label-width="150px">
                  <el-form-item label="选择不发放人员">
                    <el-select v-model="user.usercode" @change="selectGetUser" filterable="" placeholder="请选择选择发放人员">
                        <el-option v-for="item in data" :label="item.userName" :value="item.userCode" :key="item.userCode"></el-option>
                        <!-- <el-option label="区域二" value="beijing"></el-option> -->
                    </el-select>
                </el-form-item>
              </el-form>
          </el-col>
          <el-col style="margin-left:20px;" :span="10">
            {{sendUser}}
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="sendNoData">保存</el-button>
          <el-button @click="dialogVisible1 = false;sendUser='';sendUsercode=''">取 消</el-button>
        </span>
      </el-dialog>
    </el-card>
</div>
</template>
<script>
import { GetInfoList,Grant,GetUserList,SendOther } from "../../until/ZeusApiSDK/Logic/SalaryInfoLogic";
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic"; 
export default {
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  data() {
    return {
      currentUser:{},//当前登录用户信息
      tableData: [],
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading:true,
    //   filterText: "",
      user:{usercode:''},
      dialogTitle:'单独发放人员',
      dialogVisible:false,
      dialogTitle1:'不发放人员',
      dialogVisible1:false,

    //   loading:false,
      data: [], //树状节点
    //   defaultProps: {
    //     children: "children",
    //     label: "label",
    //     disabled: "type"
    //   },
      sendUser:'',//发送人员
      sendUsercode:'',//发送人员工号
      infoId:'',//当前操作数据id
    //   formLabelWidth: "120px",
    };
  },
  //亚敏进入加载方法
  created() {
    //获取当前登录信息
    this.getCurrentUser();
    //获取部门树状结构信息
    this.GetSalaryInfoList();
  },
  methods: {
    //方法区域
    //获取当前用户
    getCurrentUser:function(){
        var userinfo = window.sessionStorage.getItem("userinfo");
        userinfo = JSON.parse(Decrypt(userinfo));
        this.currentUser = userinfo;
    },
    selectGetUser:function(usercode){
        var name="";
        this.data.find((item)=>{
            if(item.userCode==usercode){
                name=item.userName;
            }
        });
        this.sendUser+=name+"("+usercode+");";
        this.sendUsercode+=usercode+",";
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetSalaryInfoList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetSalaryInfoList();
    },
    //刷新页面
    Refresh:function(){
      this.GetSalaryInfoList();
    },
    //获取列表
    GetSalaryInfoList:async function(){
      await GetInfoList(this.pageIndex,this.pageSize).then(res=>{
        this.loading=false;
        if(res.Code==200){
          this.tableData=res.Data.DataList;
          this.totalCount=res.Data.totalCount;
        }
      });
    },
    //获取审核状态
    GetStatus:function(row, column, cellValue, index){
      if(cellValue==1){
        return '财务已核对，待CEO审核';
      }
      else if(cellValue==2){
        return 'CEO已审核，待董事长同意';
      }
      else if(cellValue==3){
        return 'CEO已审核，待财务发放';
      }
      else if(cellValue==5){
        return '财务核对不通过';
      }
      else if(cellValue==6){
        return 'CEO审核不通过';
      }
      else if(cellValue==7){
        return '董事长审核不通过';
      }
      else if(cellValue==4){
        return '财务已发放';
      }
      else{
        return '人资已添加，待财务核对';
      }
    },
    //发放所有人员
    sendAll:async function(data){
      console.log('this.currentUser',this.currentUser);
      console.log('全部发放',data);
      this.infoId=data.Id;
      GetUserList(data.Id).then(res=>{
        console.log('res',res);
        if(res.Code==200){
          this.dialogVisible1=true;
          this.data=res.Data.DataList;
        }
      });

    },
    //选择不发放人员之后发放
    sendNoData:async function(){
      console.log(this.sendUsercode)
      await Grant(this.infoId,1,this.sendUsercode,this.currentUser.UserCode).then(res=>{
        if(res.Code==200){
          
          this.$message({
            message: "发放成功",
            type: "success",
            center: true
          });
          this.dialogVisible1=false;
          this.GetSalaryInfoList();
        }
        else{
          this.$message({
            message: res.Msg,
            type: "danger",
            center: true
          });
        }
      });
    },
    //撤回所有人员
    cancelAll:async function(data){
      await Grant(data.Id,2,"",this.currentUser.UserCode).then(res=>{
        if(res.Code==200){
          
          this.$message({
            message: "撤回成功",
            type: "success",
            center: true
          });
          this.GetSalaryInfoList();
        }
        else{
          this.$message({
            message: res.Msg,
            type: "danger",
            center: true
          });
        }
      });
    },
    //单独发放页面打开
    sendonly:function(data){
      this.infoId=data.Id;
      GetUserList(data.Id).then(res=>{
        console.log('res',res);
        if(res.Code==200){
          this.dialogVisible=true;
          this.data=res.Data.DataList;
        }
      });
    },
    //发送数据
    sendData:function(){
      SendOther(this.infoId,this.sendUsercode,this.currentUser.TrueName).then(res=>{
        if(res.Code==200){
          this.$message({
            message: "发放成功",
            type: "success",
            center: true
          });
          this.dialogVisible=false;
          this.GetSalaryInfoList();
        }
        else{
          this.$message({
            message: res.Msg,
            type: "danger",
            center: true
          });
        }
      });
    }
  }
};
</script>